import * as React from 'react';
import { Link } from '../../Resource/Types';
import { CurrentUserResource } from '../Types';

export const CurrentUserContext = React.createContext<CurrentUserResource | undefined>(undefined);

export type ContextType = React.ContextType<typeof CurrentUserContext>;

export const CurrentUserLinksContext = React.createContext<ReadonlyArray<Link>>([]);
